import { render, staticRenderFns } from "./user_guest_add.vue?vue&type=template&id=78b19412&scoped=true&"
import script from "./user_guest_add.vue?vue&type=script&lang=js&"
export * from "./user_guest_add.vue?vue&type=script&lang=js&"
import style0 from "./user_guest_add.vue?vue&type=style&index=0&id=78b19412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b19412",
  null
  
)

export default component.exports